import useFetchData from '../../../../../hooks/useFetchData'
import ForParent from './ForParent/ForParent'
import { useSelector } from 'react-redux'
import { Box, Container, Skeleton, Typography, Chip, Paper } from '@mui/material'
import Feeds from '../Feeds/Feeds'
import { useState } from 'react'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import ForStudent from './ForStudent/ForStudent'
import ForTeacher from './ForTeacher/ForTeacher'
import ForLeaders from './ForLeaders/ForLeaders'

// MF-559 — `dashboardEnabled` (settings.featureFlag.showDashboard) gates the dashboards; the parent's
// children list is core and always shows (MF-546).
const Wall = ({ user, checkAssessment, featureFlags, dashboardEnabled }) => {
  const userId = user?._id
  return (
    <div className='overflow-y-auto space-y-4'>
      {checkAssessment && user?.roles?.every((role) => role.name === 'Parent') && (
        <ForParent data={user?.children || []} dashboardEnabled={dashboardEnabled} />
      )}
      {checkAssessment && dashboardEnabled && user?.roles?.every((role) => role.name === 'Student') && (
        <ForStudent userId={userId} />
      )}
      {checkAssessment && dashboardEnabled && user?.roles?.some((role) => role.name === 'Teacher') && (
        <ForTeacher userId={userId} />
      )}
      {checkAssessment &&
        user?.roles?.some((role) => ['Maestro', 'Administrator', 'Principal'].includes(role.name)) && (
          <ForLeaders userData={user} />
        )}
    </div>
  )
}

export default Wall
